// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryHeading_container__3RCHY","heading":"PrimaryHeading_heading__qpY9w","sending":"PrimaryHeading_sending__geT5S"};